document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  // Forza subito lo stato trasparente
  header.classList.remove('scrolled');

  // Listener per il click: toggle della classe .clicked
  header.addEventListener('click', () => {
    header.classList.toggle('clicked');
  });

  // Funzione per aggiornare lo stato in base allo scroll
  function updateHeaderScroll() {
    if (window.scrollY > 100) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  // Aggiunge il listener per lo scroll e chiama subito la funzione
  window.addEventListener('scroll', updateHeaderScroll);
  updateHeaderScroll();

  // Se siamo in una pagina prodotto, aggiungiamo il listener per il movimento del mouse
  if (window.location.pathname.includes("/products/")) {
    document.addEventListener('mousemove', (e) => {
      // Usa header già selezionato per coerenza
      if (e.clientY < 100) {
        header.classList.add('header-white');
      } else {
        header.classList.remove('header-white');
      }
    });
  }
});
